import { render, staticRenderFns } from "./PlanoPagamentoList.vue?vue&type=template&id=59c0a770"
import script from "./PlanoPagamentoList.vue?vue&type=script&lang=js"
export * from "./PlanoPagamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports